import { Injectable, OnDestroy } from '@angular/core';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ClubLogoFacadeService } from '@app/facade-services/club-logo/club-logo-facade.service';
import { AppConfigService } from '@app/services/config/app-config.service';
import { ClubLogoService } from '@app/rest-client/faxe/services/club-logo.service';
import { ClubLogo } from '@app/rest-client/faxe/models/club-logo';

@Injectable({
  providedIn: 'root'
})
export class ClubbLoggoService implements OnDestroy {
  private unsubscribe$ = new Subject<void>();
  clubLogoMap: Map<string, ClubLogo>;
  defaultLoggoId = '39';

  constructor(private clubLogofacadeServcie: ClubLogoFacadeService) {

    this.clubLogofacadeServcie.fetchAllClubLogos('ClubbLoggoService')
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((clubLogos) => {
        this.clubLogoMap = clubLogos.reduce((map, clubLogo) => {
          map.set(clubLogo.clubName, clubLogo);
          return map;
        }, new Map<string, ClubLogo>());
      });
  }

  logoSrc(clubName: string): string {
    return `${AppConfigService.environmentConfigData.faxeServiceRootUrl}${ClubLogoService.GetClublogotypesListPath}/${this.clubLogoMap.has(clubName) ? this.clubLogoMap.get(clubName).logoId : this.defaultLoggoId}`;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
